export default function ProduceFinalMarketScore(marketData) {
    const { stateDisasters, countyDisasters, allDatapoints, totalPossiblePoints } = marketData;

    // console.log(marketData);

    let deferTo = 'countyDisasters';
    let hasSomethingToHighlight = false;
    let highlightBoth = false;

    if (countyDisasters.count > 0 && stateDisasters.count > 0) {
        highlightBoth = true;
        hasSomethingToHighlight = true;
    } else if (countyDisasters.count > 0) {
        deferTo = 'countyDisasters';
        hasSomethingToHighlight = true;
    } else if (stateDisasters.count > 0) {
        deferTo = 'stateDisasters';
        hasSomethingToHighlight = true;
    } else {
        hasSomethingToHighlight = false;
    }

    if (countyDisasters.count < 3 || countyDisasters.score === 0) {
        deferTo = 'stateDisasters';
    }

    // Get the countyDisasters and stateDisasters scores
    const countyDisastersScore = countyDisasters.score;
    const stateDisastersScore = stateDisasters.score;

    // Set the weighting between them
    const countyDisastersWeighting = .75;
    const stateDisastersWeighting = .25;

    // Get the final score
    const finalScore = (countyDisastersScore * countyDisastersWeighting) + (stateDisastersScore * stateDisastersWeighting);
    // Get the final score percentage
    const finalScorePercentage = finalScore;
    // console.log(finalScore, totalPossiblePoints, finalScorePercentage);


    // Set the thresholds for final score text, different for deferTo being countyDisasters or stateDisasters
    const countyDisastersThresholds = {
        low: 0,
        medium: 35,
        high: 70,
        veryHigh: 100
    };
    const stateDisastersThresholds = {
        low: 0,
        medium: 50,
        high: 80,
        veryHigh: 100
    };

    const getStateDisastersScoreText = (value) => {
        const absoluteValue = Math.abs(value);
        if (absoluteValue <= stateDisastersThresholds.medium) {
            return 'Low';
        } else if (absoluteValue <= stateDisastersThresholds.high) {
            return 'Medium';
        } else {
            return 'High';
        }
    }

    const getCountyDisastersScoreText = (value) => {
        const absoluteValue = Math.abs(value);
        if (absoluteValue <= countyDisastersThresholds.medium) {
            return 'Low';
        } else if (absoluteValue <= countyDisastersThresholds.high) {
            return 'Medium';
        } else {
            return 'High';
        }
    }

    // Set the final scoring text based on the final score percentage
    const finalScoreTextRating = deferTo === 'stateDisasters' ? getStateDisastersScoreText(finalScore) : getCountyDisastersScoreText(finalScore);
    const finalScorePositiveOrNegativeText = finalScorePercentage <= 0 ? 'Negative' : 'Positive';

    // Add the final score, final score percentage, final score text rating and final score positive or negative text to the initial input and retern as output
    const output = {
        ...marketData,
        finalScore,
        finalScorePercentage,
        finalScoreTextRating,
        finalScorePositiveOrNegativeText,
        deferTo,
        hasSomethingToHighlight,
        highlightBoth
    }

    // console.log("FINAL OUTPUT FROM NEW PRODUCE FINAL MARKET SCORE: ", output);

    return output;
}